import React, { Suspense, lazy } from 'react';
import { Spin } from 'antd';
import './Main.css';
import { Routes, Route } from 'react-router-dom';
import ProtectedAdminRoute from '../components/ProtectedAdminRoute';
import ProtectedRoute from '../components/ProtectedRoute';
import "antd/dist/reset.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../utils/responsive.css';

const Landing = lazy(() => import('./Landing/Landing'));
const NoPage = lazy(() => import('./404Page/NoPage'));
const Profile = lazy(() => import('./Profile/Profile'));
const Admin = lazy(() => import('./Admin/Admin'));
const Map = lazy(() => import('./MapPage/MapPage'));
const LoginPage = lazy(() => import('./Auth/LoginPage'));
const RegPage = lazy(() => import('./Auth/RegPage'));
const RecoveryPage = lazy(() => import('./Auth/RecoveryPage'));
const PasswordPage = lazy(() => import('./Auth/PasswordPage'));
const NewsPage = lazy(() => import('./NewsPage/NewsPage'));
const ArticlePage = lazy(() => import('./NewsPage/ArticlePage'));
const DroneInfo = lazy(() => import('./DroneInfo/DroneInfo'));
const PermissionPage = lazy(() => import('./Permission/PermissionPage'));

const PageLoader = () => (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
    </div>
);

const Main = () => {
    return (
        <div className="Main_wrapper">
            <div className="Main_wrap">
                <Suspense fallback={<PageLoader />}>
                    <Routes>
                        <Route path="/" element={<Landing />} />

                        <Route path="/reg" element={<RegPage />} />
                        <Route path="/recovery" element={<RecoveryPage />} />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedAdminRoute>
                                    <Admin />
                                </ProtectedAdminRoute>
                            }
                        />
                        <Route
                            path="/profile"
                            element={
                                <ProtectedRoute>
                                    <Profile />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="/map" element={<Map />} />
                        <Route path="/information" element={<DroneInfo />} />
                        <Route path="/News" element={<NewsPage />} />
                        <Route path="/News/:id" element={<ArticlePage />} />
                        <Route path="/permission/:id" element={<PermissionPage />} />
                        <Route path="/password" element={<PasswordPage />} />
                        <Route path="*" element={<NoPage />} />

                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<RegPage />} />

                        <Route path="/auth/password" element={<PasswordPage />} />
                        <Route
                            path="/admin/:token"
                            element={
                                <ProtectedAdminRoute>
                                    <Admin />
                                </ProtectedAdminRoute>
                            }
                        />
                    </Routes>
                </Suspense>
            </div>
        </div>
    );
};

export default Main;
